/**
 * @file logging.ts
 * @description Configuration of the logging level for the frontend application.
 * Uses the 'loglevel' library to manage log levels based on the execution environment
 * (development or production).
 */

import log from "loglevel";

const isProduction = process.env.REACT_APP_ENV === "production";

if (isProduction) {
  log.setLevel("silent");
} else {
  log.setLevel("debug");
}

export default log;
